import BarcodeModal from './BarcodeModal';
import { IInitialState } from 'src/store/initialState';
import { connect } from 'react-redux';
import {
  returnsActions,
  returnIsDownloadingPdfSel
} from 'src/store/modules/returns';

import {
  activeAccountSel
} from 'src/store/modules/signin';

const mapStateToProps = (state: IInitialState) => ({
  isDownloadingPdf: returnIsDownloadingPdfSel(state),
  accountID: activeAccountSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  downloadPdf: (rmaNumber: string, isPrepaidLabel: string) => {
    dispatch(returnsActions.downloadPdf(rmaNumber, isPrepaidLabel));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BarcodeModal);
